var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { uniqueId } from 'lodash';
import { EntityIcon, useEntityTypeIcons } from '@shapeable/icons';
var cls = classNames('entity-type-count-icon');
export var EntityTypeCountIconDefaultProps = {
  glyphSize: 32,
  size: 48,
  color: 'light',
  fill: 'primary',
  hoverColor: 'light',
  hoverFill: 'strong'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n\n    ", "\n\n   \n\n\n  "], ["\n    cursor: pointer;\n\n    ", "\n\n   \n\n\n  "])), function (props) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ", ", ", ", " {\n        fill: ", ";\n        ", ";\n      }\n\n      ", " {\n        fill: ", ";\n      }\n\n      &:hover {\n        ", ", ", ", ", " {\n          fill: ", ";\n          ", ";\n        }\n\n        ", " {\n          fill: ", ";\n        }\n      }\n      \n    "], ["\n      ", ", ", ", ", " {\n        fill: ", ";\n        ", ";\n      }\n\n      ", " {\n        fill: ", ";\n      }\n\n      &:hover {\n        ", ", ", ", ", " {\n          fill: ", ";\n          ", ";\n        }\n\n        ", " {\n          fill: ", ";\n        }\n      }\n      \n    "])), cls.child('ring'), cls.child('text'), cls.child('glyph'), theme.COLOR(props._color), theme.FILL(props._color), cls.child('fill'), theme.COLOR(props._fill), cls.child('ring'), cls.child('text'), cls.child('glyph'), theme.COLOR(props._hoverColor), theme.FILL(props._hoverColor), cls.child('fill'), theme.COLOR(props._hoverFill));
  })
});
var CountStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 26px;\n    font-weight: bold;\n  "], ["\n    font-size: 26px;\n    font-weight: bold;\n  "])))
});
var FillStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RingStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.svg(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Ring: styled.circle.attrs(cls.attr('ring'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  Fill: styled.circle.attrs(cls.attr('fill'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FillStyles),
  Count: styled.text.attrs(cls.attr('text'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CountStyles)
};
export var EntityTypeCountIcon = function (props) {
  var className = props.className,
    children = props.children,
    glyphSize = props.glyphSize,
    count = props.count,
    size = props.size,
    onClick = props.onClick,
    color = props.color,
    fill = props.fill,
    hoverColor = props.hoverColor,
    hoverFill = props.hoverFill;
  var maskId = "id-".concat(uniqueId());
  var glyphs = useEntityTypeIcons();
  var entityTypeNames = props.entityTypeNames || props.entityTypeName && [props.entityTypeName] || [];
  var TooManyGlyph = EntityIcon;
  var GLYPH_SIZE_FOR_LENGTH = [38, 30, 20, 18, 18];
  var Y_ORIGIN_FOR_LENGTH = [48, 44, 46, 42, 42];
  var yOrigin = entityTypeNames.length <= 5 ? Y_ORIGIN_FOR_LENGTH[entityTypeNames.length - 1] : Y_ORIGIN_FOR_LENGTH[0] - 4;
  var GAP = 4;
  return React.createElement(My.Container, {
    _color: color,
    _fill: fill,
    _hoverColor: hoverColor,
    _hoverFill: hoverFill,
    onClick: onClick,
    width: size,
    height: size,
    className: cls.name(className),
    viewBox: "0 0 96 96"
  }, React.createElement("defs", null, React.createElement("mask", {
    id: maskId
  }, React.createElement("rect", {
    width: 96,
    height: 96,
    style: {
      fill: 'white'
    }
  }), React.createElement("circle", {
    cx: "48",
    cy: "48",
    r: "44",
    style: {
      fill: 'black'
    }
  }))), React.createElement(My.Ring, {
    cx: 48,
    cy: 48,
    r: 48,
    fill: color,
    mask: "url(#".concat(maskId, ")")
  }), fill && React.createElement(My.Fill, {
    cx: 48,
    cy: 48,
    r: 44,
    fill: fill
  }), React.createElement(My.Count, {
    fill: color,
    x: 48,
    y: 28,
    textAnchor: "middle",
    alignmentBaseline: 'middle'
  }, count), entityTypeNames.length > 5 && React.createElement(TooManyGlyph, {
    variant: "glyph",
    className: cls.sub('glyph'),
    glyphFit: "fit",
    size: GLYPH_SIZE_FOR_LENGTH[0],
    y: 48,
    x: 48 - GLYPH_SIZE_FOR_LENGTH[0] / 2
  }), entityTypeNames.length <= 5 && entityTypeNames.map(function (entityTypeName, index) {
    var size = GLYPH_SIZE_FOR_LENGTH[entityTypeNames.length - 1];
    var lineNumber = Math.floor(index / 3);
    var lineLength = Math.min(entityTypeNames.length, lineNumber === 0 ? 3 : 2);
    var lineIndex = lineNumber === 0 ? index : index - 3;
    var xOrigin = 48 - (lineLength * (size + GAP) - GAP) / 2;
    var y = yOrigin + lineNumber * (size + GAP);
    var x = xOrigin + lineIndex * (size + GAP);
    var Glyph = glyphs[entityTypeName] || EntityIcon;
    return React.createElement(Glyph, {
      variant: "glyph",
      className: cls.sub('glyph'),
      key: index,
      glyphFit: "fit",
      size: size,
      y: y,
      x: x
    });
  }));
};
EntityTypeCountIcon.defaultProps = EntityTypeCountIconDefaultProps;
EntityTypeCountIcon.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;